export class DialogModelMultipleImages {
    constructor(
      public imageUrls: any
    ) {}
  }